import styled, { css } from 'styled-components';
import { colors, MediaQuery } from '../../../../theme/style-helpers';

export const Container = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 24px;
    padding-top: 32px;

    ${MediaQuery.xLarge(css`
        row-gap: 40px;
    `)};
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${MediaQuery.medium(css`
        display: grid;
        grid-template-columns: auto 156px;
    `)};
`;

export const Info = styled.p`
    margin: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: ${colors.BLACK};

    ${MediaQuery.medium(css`
        font-size: 16px;
    `)};
`;

export const Content = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 20px;

    ${MediaQuery.xLarge(css`
        grid-template-columns: repeat(3, 1fr);
        grid-auto-flow: unset;
        column-gap: 24px;
    `)};
`;
